import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getLabList
 * @param pageNo, searchText, stateName
 * @description This function  will fetch the lab list.
 */
export const getLabList = (pageNo, searchText, stateName) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/labs?page=${pageNo}&perpage=10`;

  if (searchText) {
    url = url + "&search_text=" + searchText;
  }

  if (stateName) {
    url = url + "&filter_type=state&filter_text=" + stateName;
  }
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function getLabDetails
 * @param  labId
 * @desc  get lab details
 */

export const getLabDetails = labId => {
  let url = `${process.env.REACT_APP_SERVER_URL}/admin/labs/${labId}`;
  return axios.get(url, {
    headers: getAuthHeaders()
  });
};
